import { useAuth } from '@/hooks';
import { hasAnyRole } from '@/lib/permissions';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface RequireRoleProps {
    roles: string[];
    children: ReactNode;
}

export function RequireRole({ roles, children }: RequireRoleProps) {
    const { data: authData, isLoading } = useAuth();

    if (isLoading) {
        return null;
    }

    if (!hasAnyRole(authData?.user, roles)) {
        return <Navigate to="/quotes" replace />;
    }

    return <>{children}</>;
}
